import { render, staticRenderFns } from "./ProductionName.vue?vue&type=template&id=480e77bc&scoped=true&"
import script from "./ProductionName.vue?vue&type=script&lang=js&"
export * from "./ProductionName.vue?vue&type=script&lang=js&"
import style0 from "./ProductionName.vue?vue&type=style&index=0&id=480e77bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e77bc",
  null
  
)

export default component.exports